import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { EButtonType } from "../../../data-types/button.enum";
import { iconsLibrary } from "../../../../theme/constants";
import { NavigationEnd, Route, Router } from "@angular/router";
import { LocalStorageService } from "../../../services/local-storage.service";
import { EStorageType } from "../../../data-types/storage.enum";
import { CowingInputDropdownComponent } from "../cowing-input-dropdown/cowing-input-dropdown.component";
import { EInputStyleType } from "../../../data-types/input-style.enum";
import { CompanyService } from "../../../services/company.service";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../../store/actions/loading.action";
import { IAppState } from "../../../store/state/app.state";
import { Store } from "@ngrx/store";
import { showAlertAction } from "../../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { CoworkingService } from "../../../services/coworking.service";
import { Local } from "protractor/built/driverProviders";
import { UserService } from "../../../services/user.service";
import { identifierName } from "@angular/compiler";
enum MenuType {
  Profile = "profile",
  Notifications = "notifications",
}

declare const window;

@Component({
  selector: "header-home",
  templateUrl: "./header-home.component.html",
  styleUrls: ["./header-home.component.scss"],
})
export class HeaderHomeComponent implements OnInit, OnDestroy {
  showMenu = false;
  dropdownCoworkingMenu = false;
  allCoworkings = [];
  public EInputStyleType = EInputStyleType;
  public EStorageType = EStorageType;
  public menuContent: MenuType = MenuType.Profile;
  public MenuType = MenuType;
  id: string;
  constructor(
    private router: Router,
    private _store: Store<IAppState>,
    private translate: TranslateService,
    private CoworkingService: CoworkingService,
    private users: UserService,
    private _company: CompanyService,
    private _coworking: CoworkingService
  ) {}
  get getLogo() {
    if (this.router.url === "/coworking-home/bookings") {
      return `${iconsLibrary.calendarActiveGreenSvg}`;
    } else if (this.router.url === "/coworking-home") {
      return `${iconsLibrary.monitorActiveGreenSvg}`;
    } else if (this.router.url === "/coworking-home/spaces") {
      return `${iconsLibrary.boxActiveGreenSvg}`;
    } else if (this.router.url === "/company-home") {
      return `${iconsLibrary.monitorActiveGreenSvg}`;
    } else if (this.router.url === "/company-home/employees") {
      return `${iconsLibrary.greenUser}`;
    } else if (this.router.url === "/company-home/booking") {
      return `${iconsLibrary.calendarActiveGreenSvg}`;
    } else if (this.router.url === "/company-home/spendings") {
      return `${iconsLibrary.creditcardActiveGreenSvg}`;
    } else if (this.router.url === "/company-home/spaces") {
      return `${iconsLibrary.boxActiveGreenSvg}`;
    } else {
      return `${iconsLibrary.lock}`;
    }
  }
  async ngOnInit() {
    await this.getInfo();
    // CoworkingService.instance.newCoworkingAdded.subscribe(
    //   async (value: any) => {
    //     const newInfo = await CoworkingService.instance.getCoworkingInfo(value);
    //     let oldInfo = JSON.parse(
    //       LocalStorageService.instance.get(EStorageType.Coworking)
    //     );
    //     oldInfo.push(newInfo);
    //     LocalStorageService.instance.set(
    //       EStorageType.Coworking,
    //       JSON.stringify(oldInfo)
    //     );
    //   }
    // );
    // CompanyService.instance.newCompanyAdded.subscribe(async (value: any) => {
    //   const newInfo = await CompanyService.instance.getCompanyInfo(value);
    //   let oldInfo = JSON.parse(
    //     LocalStorageService.instance.get(EStorageType.Company)
    //   );
    //   oldInfo.push(newInfo);
    //   LocalStorageService.instance.set(
    //     EStorageType.Company,
    //     JSON.stringify(oldInfo)
    //   );
    // });
  }

  async getInfo() {
    //  FUTURE, DIFFERENT ROLES => IF ROLE ....... EStorageType = ROLE
    if (LocalStorageService.instance.get(EStorageType.Role) === "coworking") {
      this.id = LocalStorageService.instance.get(EStorageType.ActiveCoworking);
      // CoworkingService.instance.coworkingModified.subscribe(async (val) => {
      this._store.dispatch(showLoadingAction({}));
      try {
        const newInfo = await CoworkingService.instance.getCoworkingInfo(
          this.id
        );
        let oldInfo = JSON.parse(
          LocalStorageService.instance.get(EStorageType.Coworking)
        );
        let newCoworkingsInfo = oldInfo.map((coworking) => {
          if (coworking.active) {
            coworking.company_name = newInfo.company_name;
            coworking.fiscal_address = newInfo.fiscal_address;
            coworking.id = newInfo.id;
            coworking.image = newInfo.images["1"];
            return coworking;
          } else {
            return coworking;
          }
        });
        LocalStorageService.instance.set(
          EStorageType.Coworking,
          JSON.stringify(newCoworkingsInfo)
        );
      } catch (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message: e.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      } finally {
        this._store.dispatch(closeLoadingAction({}));
      }
      // });
      this.allCoworkings = JSON.parse(
        LocalStorageService.instance.get(EStorageType.Coworking)
      );
    } else if (
      LocalStorageService.instance.get(EStorageType.Role) === "company" ||
      LocalStorageService.instance.get(EStorageType.Role) === "company-plus"
    ) {
      this.id = LocalStorageService.instance.get(EStorageType.ActiveCompany);
      // CompanyService.instance.companyModified.subscribe(async (val) => {
      this._store.dispatch(showLoadingAction({}));
      try {
        const newInfo = await CompanyService.instance.getCompanyInfo(this.id);
        let oldInfo = JSON.parse(
          LocalStorageService.instance.get(EStorageType.Company)
        );
        let newCompaniesInfo = oldInfo.map((company) => {
          if (company.active) {
            company.company_name = newInfo.company_name;
            company.fiscal_address = newInfo.fiscal_address;
            company.id = newInfo.id;
            company.image = newInfo.image;
            return company;
          } else {
            return company;
          }
        });
        LocalStorageService.instance.set(
          EStorageType.Company,
          JSON.stringify(newCompaniesInfo)
        );
      } catch (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      } finally {
        this._store.dispatch(closeLoadingAction({}));
      }
      // });

      this.allCoworkings = JSON.parse(
        LocalStorageService.instance.get(EStorageType.Company)
      );
    }
  }
  ngOnDestroy() {
    // CoworkingService.instance.coworkingModified.unsubscribe();
    // CompanyService.instance.companyModified.unsubscribe();
  }
  public get getRole() {
    return LocalStorageService.instance.get(EStorageType.Role);
  }
  public changeCoworking(newId) {
    if (this.getRole === "coworking")
      LocalStorageService.instance.set(EStorageType.ActiveCoworking, newId);
    if (this.getRole === "company" || this.getRole === "company-plus")
      LocalStorageService.instance.set(EStorageType.ActiveCompany, newId);
    if (this.allCoworkings && this.allCoworkings.length > 0) {
      const resetCoworkings = this.allCoworkings.map((coworking) => {
        if (coworking.id == newId) {
          coworking.active = true;
          return coworking;
        }
        coworking.active = false;
        return coworking;
      });

      if (this.getRole === "coworking") {
        LocalStorageService.instance.set(
          EStorageType.Coworking,
          JSON.stringify(resetCoworkings)
        );
        this.id = LocalStorageService.instance.get(
          EStorageType.ActiveCoworking
        );
      }
      if (this.getRole === "company" || this.getRole === "company-plus") {
        LocalStorageService.instance.set(
          EStorageType.Company,
          JSON.stringify(resetCoworkings)
        );
        this.id = LocalStorageService.instance.get(EStorageType.ActiveCompany);
      }
    }

    this.dropdownCoworkingMenu = false;
  }
  get getCoworkingName() {
    return this.allCoworkings && this.allCoworkings.length
      ? this.allCoworkings.find((cow) => cow.id == this.id).company_name
      : "Error";
  }
  get getTitle() {
    if (this.router.url === "/coworking-home/bookings") {
      return "Reservas";
    } else if (this.router.url === "/coworking-home") {
      return "Home";
    } else if (this.router.url === "/coworking-home/spaces") {
      return "Espacios";
    } else if (this.router.url === "/company-home") {
      return "Empresa";
    } else if (this.router.url === "/company-home/employees") {
      return "Empleados";
    } else if (this.router.url === "/company-home/booking") {
      return "Reservas";
    } else if (this.router.url === "/company-home/spendings") {
      return "Consumos";
    } else if (this.router.url === "/company-home/spaces") {
      return "Espacios";
    }
  }

  get getProfilePhoto() {
    const image =
      this.allCoworkings && this.allCoworkings.length
        ? this.allCoworkings.find((cow) => cow.id == this.id).image
        : iconsLibrary.landingImage;
    return image ? image : `${iconsLibrary.landingImage}`;
  }

  get getNotificationsIcon() {
    return `${iconsLibrary.notificationsSvg}`;
  }

  get defaultImage() {
    return `${iconsLibrary.landingImage}`;
  }
  get getCloseIcon() {
    return `${iconsLibrary.closeSvg}`;
  }
  get getChevronIcon() {
    return `${iconsLibrary.chevronSvg}`;
  }

  get getChevronDownIcon() {
    return `${iconsLibrary.chevronDownSvg}`;
  }

  get inactiveCoworkings() {
    return this.allCoworkings.filter((coworking) => !coworking.active);
  }
  get getFiscalAddress() {
    return this.allCoworkings.find((cow) => cow.id == this.id).fiscal_address;
  }

  public navigateTo(link) {
    console.log(link);
    this.router.navigate([`${link}`]);
  }

  public showHideMenu(type: MenuType) {
    if (this.allCoworkings && this.allCoworkings.length) {
      this.menuContent = type;
      if (this.showMenu) {
        document.getElementById("sidenav").classList.add("bye");
        setTimeout(() => {
          this.showMenu = false;
        }, 500);
      } else {
        this.showMenu = true;
      }
    }
  }

  public requestPwdRecovery() {
    // Check the role
    let id = null;
    let email = null;
    if (LocalStorageService.instance.get(EStorageType.Company)) {
      id = JSON.parse(LocalStorageService.instance.get(EStorageType.Company))[0]
        .id;
      console.log("id:", id);

      this._company
        .getCompanyInfo(id)
        .then((info) => {
          email = info.email;
          if (email) {
            this.sentPwdEmail(email);
          }
        })
        .catch((error) => {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message:
                  error.status === 401
                    ? this.translate.instant("general.expired")
                    : error.data.error,
                title: this.translate.instant("pwd-recovery.caution"),
                type: "error",
              },
            })
          );
        });
    } else if (LocalStorageService.instance.get(EStorageType.Coworking)) {
      id = JSON.parse(
        LocalStorageService.instance.get(EStorageType.Coworking)
      )[0].id;

      this._coworking
        .getCoworkingInfo(id)
        .then((info) => {
          email = info.email;
          if (email) {
            this.sentPwdEmail(email);
          }
        })
        .catch((error) => {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message:
                  error.status === 401
                    ? this.translate.instant("general.expired")
                    : error.data.error,
                title: this.translate.instant("pwd-recovery.caution"),
                type: "error",
              },
            })
          );
        });
    }
  }

  public openPage(url: string) {
    window.open(url, "_blank");
  }

  public openFaqs() {
    let url = "";
    if (LocalStorageService.instance.get(EStorageType.Company)) {
      url = "https://cowing.es/faqs-empresas";
    } else {
      url = "https://cowing.es/faqs-workspaces";
    }
    window.open(url, "_blank");
  }

  private sentPwdEmail(email) {
    this.users
      .requestPwdRecovery(email)
      .then(() => {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message: this.translate.instant("login.success"),
              title: this.translate.instant("login.done"),
              type: "alert",
            },
          })
        );
      })
      .catch((error) => {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                error.status === 401
                  ? this.translate.instant("general.expired")
                  : error.data.error,
              title: this.translate.instant("pwd-recovery.caution"),
              type: "error",
            },
          })
        );
      });
  }
}
